<template>
  <v-sheet data-testid="your_vision_specialist"
    v-if="contact_person || contact_clinic || has_custom_help_text"
    :elevation="elevation"
    :style="(elevation ? 'padding: 30px;' :'') + 'font-size: 16px;'"
  >
  <h2 style="margin-bottom: 10px">{{ title }}</h2>
  <template v-if="has_custom_help_text">
      <QuillView :value="custom_help_text_linkified" />
    </template>
    <template v-else>
      <p v-if="show_desc">{{ $t("your_vision_specialist.for_vision_therapy_related_questions") }}</p>

      <p style="font-weight: 500;">
        <span
          v-if="contact_person"
        >
          {{ contact_person.name_prefix }} {{ contact_person.name_given }} {{ contact_person.name_family }}
        </span>
        <span v-if="contact_person && contact_clinic">,&nbsp;</span>
        <span v-if="contact_clinic">{{ contact_clinic.title }}</span>
      </p>
      <p style="font-weight: 500;">
        <span v-if="contact_email">
          <a :href="'mailto:' + contact_email">{{ contact_email }}</a>
          <br />
        </span>
        <span v-if="contact_clinic && contact_clinic.phone">{{ contact_clinic.phone }}</span>
      </p>

      <p v-if="contact_clinic && contact_clinic.website">
        <span v-if="website_view">
          <a :href="website_link" target="_blank">{{ website_view }}</a>
        </span>
      </p>
    </template>
  </v-sheet>
</template>

<script>
import QuillView from "./QuillView.vue";

export default {
  components: { QuillView },
  props: {
    contact_person: {
      type: Object,
      default: () => null,
    },
    contact_clinic: {
      type: Object,
      default: () => null,
    },
    custom_help_text: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Your Vision Specialist",
    },
    elevation: {
      type: Number,
      default: 2,
    },
    show_desc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    has_custom_help_text() {
      return this.custom_help_text && this.custom_help_text.trim().replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim() !== '';
    },
    custom_help_text_linkified() {
      let html = this.custom_help_text;
      if (!html || typeof html !== 'string') return html || '';
      const placeholders = [];
      const placeholderPrefix = '\u0001A\u0001';
      html = html.replace(/<a\s[\s\S]*?<\/a>/gi, (match) => {
        const idx = placeholders.length;
        placeholders.push(match);
        return placeholderPrefix + idx + '\u0001';
      });
      const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      const linkifyUrl = (url) => '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' + escapeHtml(url) + '</a>';
      const linkifyEmail = (email) => '<a href="mailto:' + escapeHtml(email) + '">' + escapeHtml(email) + '</a>';
      html = html.replace(/(^|[\s>])(https?:\/\/[^\s<>"')\]]+)/g, (_, before, url) => before + linkifyUrl(url));
      html = html.replace(/(^|[\s>])(www\.[^\s<>"')\]]+)/g, (_, before, url) => before + '<a href="http://' + escapeHtml(url) + '" target="_blank" rel="noopener">' + escapeHtml(url) + '</a>');
      html = html.replace(/(^|[\s>])([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, (_, before, email) => before + linkifyEmail(email));
      html = html.replace(new RegExp(placeholderPrefix + '(\\d+)\u0001', 'g'), (_, idx) => placeholders[parseInt(idx, 10)] || '');
      return html;
    },
    contact_email() {
      if (this.contact_clinic && this.contact_clinic.has_tag('clinic_email')) {
        return this.contact_clinic.tag_value('clinic_email')
      }
      if (this.contact_person && (!this.contact_clinic || !this.contact_clinic.has_tag('private_email'))) {
        return this.contact_person.email
      }
      return ""
    },
    website_view() {
      if (!this.contact_clinic || !this.contact_clinic.website) {
        return "";
      }
      return this.contact_clinic.website.replace(/(^\w+:|^)\/\//, "");
    },
    website_link() {
      if (!this.contact_clinic || !this.contact_clinic.website) {
        return "";
      }
      if (this.contact_clinic.website.startsWith("http://") || this.contact_clinic.website.startsWith("https://")) {
        return this.contact_clinic.website;
      } else {
        return "http://" + this.contact_clinic.website;
      }
    },
  }
};
</script>
